import type { LaboratoryStroageData } from "shared/native-module";

export type LaboratoryKey = keyof LaboratoryStroageData;

export type LaboratoryItem = {
  experimentId: string;
  title: string;
  description: string | null;
}

export const LABORATORY_ITEMS: Record<LaboratoryKey, LaboratoryItem> = {
  IS_LIKE_FOLDER: {
    experimentId: "like_folder",
    title: "찜할 때마다 서랍 선택",
    description: "상품 찜을 할 때마다 서랍 선택을 하는 것이 번거로우셨다면, 선택 기능을 꺼두실 수 있어요. 이 기능을 끄시면 찜한 상품은 기본 서랍에 담기게 됩니다.",
  },
  IS_GIF_IMAGE: {
    experimentId: "gif_image",
    title: "움직이는 이미지(gif) 기능",
    description: "상품 이미지를 멈추고 싶다면, 움직이는 이미지(gif) 기능을 꺼주세요.",
  },
  IS_TOUCH_VIBRATION: {
    experimentId: "haptic",
    title: "화면 터치 시 진동 기능",
    description: null,
  },
  IS_SELECT_GOODS_SCREEN_SHOT_SHARE: {
    experimentId: "after_screen_capture_share",
    title: "상세페이지 캡처 시 바로 공유하기",
    description: "상품 상세페이지에서 스크린샷을 찍을 때 공유하기 화면이 자동으로 뜨는 것이 번거롭다면, 이 기능을 꺼주세요.",
  },
};